import styled from 'styled-components/macro';
import {useState} from "react";
import {useActions, useLoggedIn, useSettings} from "../store";
import {useFeedback} from "../store/feedback";
import {useCommunities} from "../api/communities";
import CommunityLogo from "./community_logo";
import NavLink from "./nav_link";
import MobileSidebarContainer from "./mobile_sidebar_container";
import {themecolors} from "../utils/themecolors";
import useLogout from "../api/logout";
import {useHistory} from "react-router-dom";
import {
    Smartphone,
    Search as LucideSearch,
    Home,
    TrendingUp,
    Compass,
    Plus,
    Bookmark,
    User,
    Vote,
    Bell, EyeOff, LogOut, Settings, Moon, Lock, Gavel, Scale
} from "lucide-react";

const Container = styled.div``;
const Search = styled.div``;
const SearchIcon = styled.div``;
const Item = styled.div``;
const Icon = styled.div``;
const Name = styled.div``;
const Footer = styled.div``;
const Separator = styled.div``;
const Heading = styled.div``;
const ViewMore = styled.div``;

const SidebarItem = ({name, location, children, onClose, react_route}) => {
    return (
        <NavLink href={location} onClick={onClose} react_route={react_route}>
            <Item>
                <Icon>{children}</Icon>
                <Name>{name}</Name>
            </Item>
        </NavLink>
    );
};

const MobileNetworkSidebar = styled(({className, onClose}) => {
    const {error, feedbackCh} = useFeedback();
    const loggedIn = useLoggedIn();
    const {subscribed, community_creation} = useSettings();
    const subscriptions = useCommunities(feedbackCh, subscribed);
    const other = useCommunities(feedbackCh, ['Unexpected', 'Ladies', 'ParallelSociety', 'Hmmm',
        'OhTwitter', 'frenworld', 'Conspiracies', 'starwars', 'MillionDollarExtreme', 'GameDev']);
    const [query, setQuery] = useState('');
    const settings = useSettings();
    const actions = useActions();
    const onInputChange = (event) => {
        setQuery(event.target.value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        window.location.href = `/search?query=${query}`;
        onClose();
    }
    const handleTheme = async () => {
        const changes = {theme: settings.theme === 'light' ? 'dark' : 'light'};
        actions.settingsChanged(changes);
        onClose();
    };
    const handleMobileSite = () => {
        document.cookie = "forcePlatform=mobile; path=/; expires=Tue, 19 Jan 2038 03:14:07 UTC;";
        document.cookie = "forceDesktop=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        window.location.reload(true);
    };

    const logout = useLogout(feedbackCh);
    const history = useHistory();
    const handleLogout = async () => {
        try {
            await logout();
            history.replace('/');
        } catch {
        }
    };

    return (
        <div className={className}>
            <MobileSidebarContainer onClose={onClose}>
                <Container>
                    <Search>
                        <SearchIcon>
                            <LucideSearch size={18}/>
                        </SearchIcon>
                        <form onSubmit={handleSubmit}>
                            <input className="search-input" type="text" placeholder="Search for a post..."
                                   onChange={onInputChange}/>
                        </form>
                    </Search>

                    <Item onClick={handleMobileSite}>
                        <Icon><Smartphone size={20}/></Icon>
                        <Name>Opt Into Mobile Site</Name>
                    </Item>

                    <Separator/>

                    <SidebarItem name={'Home'} location={'/'} onClose={onClose} react_route><Home
                        size={20}/></SidebarItem>
                    <SidebarItem name={'Trending'} location={'/c/all'} onClose={onClose} react_route><TrendingUp
                        size={20}/></SidebarItem>
                    <SidebarItem name={'Communities'} location={'/communities'} onClose={onClose} react_route><Compass
                        size={20}/></SidebarItem>
                    {community_creation &&
                    <SidebarItem name={'New Community'} location={'/create'} onClose={onClose}
                                 react_route><Plus size={20}/></SidebarItem>
                    }

                    <Separator/>

                    <SidebarItem name={'Profile'} location={'/u/me'} onClose={onClose} react_route><User
                        size={20}/></SidebarItem>
                    <SidebarItem name={'Saved'} location={'/saved'} onClose={onClose} react_route><Bookmark size={20}/></SidebarItem>
                    <SidebarItem name={'Upvoted'} location={'/upvoted'} onClose={onClose} react_route><Vote size={20}/></SidebarItem>
                    <SidebarItem name={'Hidden'} location={'/hidden'} onClose={onClose} react_route><EyeOff size={20}/></SidebarItem>
                    <SidebarItem name={'Messages'} location={'/messages'} onClose={onClose} react_route><Bell
                        size={20}/></SidebarItem>
                    {loggedIn &&
                    <Item onClick={() => {
                        handleLogout();
                        onClose();
                    }}>
                        <Icon><LogOut size={20}/></Icon>
                        <Name>Logout</Name>
                    </Item>
                    }

                    <Separator/>

                    {loggedIn &&
                    <>
                        <Heading>
                            Your Communities
                        </Heading>

                        {subscriptions?.map((community) => community && (
                            <SidebarItem key={community.name} name={community.name} location={`/c/${community.name}`}
                                         onClose={onClose}>
                                <CommunityLogo name={community.name}/>
                            </SidebarItem>
                        ))}
                    </>
                    }

                    <Separator/>

                    <Heading>
                        More Communities
                        <ViewMore>
                            <NavLink href={'/communities?sort=topics&topic=All'} react_route onClick={onClose}>
                                View All
                            </NavLink>
                        </ViewMore>
                    </Heading>

                    {other?.map((community) => community && (
                        <SidebarItem key={community.name} name={community.name} location={`/c/${community.name}`}
                                     onClose={onClose} react_route>
                            <CommunityLogo name={community.name}/>
                        </SidebarItem>
                    ))}

                    <Separator/>

                    <SidebarItem name={'Privacy Policy'}
                                 location={'https://help.scored.co/knowledge-base/privacy-policy/'}
                                 onClose={onClose}><Lock size={18} /></SidebarItem>
                    <SidebarItem name={'Terms of Service'}
                                 location={'https://help.scored.co/knowledge-base/terms-of-service/'} onClose={onClose}><Gavel size={18} /></SidebarItem>
                    <SidebarItem name={'Content Policy'}
                                 location={'https://help.scored.co/knowledge-base/content-policy/'}
                                 onClose={onClose}><Scale size={18} /></SidebarItem>

                </Container>
                <Footer>
                    <NavLink href={'/settings'} react_route onClick={onClose}>
                        <Settings size={20}/> Settings
                    </NavLink>
                    <Moon size={20} onClick={handleTheme}/>
                </Footer>
            </MobileSidebarContainer>
        </div>
    )
})`
  ${MobileSidebarContainer} {
    left: 0;
  }

  ${Container} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    border-right: ${({theme}) => theme.color.name === 'dark' ? `1px solid ${theme.dark_border}` : 'none'};
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 72px;
  }

  ${Search} {
    position: relative;
    padding: 16px;
  }

  ${SearchIcon} {
    position: absolute;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    font-size: 16px;
    margin-top: 11px;
    margin-left: 12px;
  }

  ${Search} input {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    padding: 12px 12px 12px 36px;
    border: none;
    border-radius: 6px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_field : themecolors.light_input};
  }
  ${Search} input::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Icon} {
    font-size: 20px;
    margin-right: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    width: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  ${Icon} img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  ${Item} {
    display: flex;
    align-items: center;
    padding: 8px 24px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${Footer} {
    position: absolute;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : themecolors.pure_white};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    bottom: 0;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
    padding: 0 16px;
  }

  ${Footer} svg {
    font-size: 16px;
  }

  ${Footer} svg:first-of-type {
    margin-right: 12px;
  }

  ${Footer} svg:last-of-type {
    margin-left: auto;
  }

  ${Separator} {
    width: 100%;
    height: 1px;
    margin: 12px 0;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : themecolors.lighter_border};
  }

  ${Heading} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    padding: 0 24px;
    font-weight: 500;
    font-size: 14px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
  }

  ${ViewMore} {
    margin-left: auto;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Footer} a {
    display: flex;
    align-items: center;
  }
`;

export default MobileNetworkSidebar;
